package com.milta.core.localization.translations.it

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PROFILO DELL'ORGANIZZAZIONE",
    profileNameLabel = "Nome dell'organizzazione",
    languageSectionTitle = "LINGUA DELL'INTERFACCIA",
    languageSearchPlaceholder = "Cerca una lingua...",
    languageMoreAvailable = "%d altre lingue disponibili",
    languageErrorGeneric = "Si è verificato un errore. Riprova.",
    subscriptionSectionTitle = "ABBONAMENTO",
    subscriptionPlanLabel = "Piano",
    subscriptionBillingLabel = "Fatturazione",
    subscriptionRenewalLabel = "Prossimo rinnovo",
    subscriptionBillingMonthly = "Mensile",
    subscriptionBillingAnnual = "Annuale",
    subscriptionPlanOrganisationLabel = "Organizzazione (Responsabile + team)",
    subscriptionPriceSuffix = "IVA esclusa / mese",
    subscriptionUnavailable = "Non disponibile",
    deleteSectionTitle = "Elimina l'organizzazione",
    deleteWarning = "Questa azione è permanente e irreversibile.",
    deleteDescription = "I giri di consegna e le prove di consegna verranno eliminati. Gli account degli autisti verranno dissociati dall'organizzazione, ma mai eliminati.",
    deleteConfirmLabel = "Per confermare, inserisci il nome dell'organizzazione",
    deleteButton = "Elimina definitivamente",
    deleteFinalDialogTitle = "Confermare l'eliminazione definitiva?",
    deleteFinalDialogMessage = "Questa azione non può essere annullata. L'organizzazione, i suoi giri e le prove di consegna verranno eliminati definitivamente.",
    deleteErrorGeneric = "Si è verificato un errore. Riprova.",
)
